import axios from "axios";
import md5 from 'md5';

// axios.defaults.baseURL = '/api'
axios.defaults.baseURL = 'https://apis.llmaitengff.com/'
axios.defaults.timeout = 10000
axios.defaults.headers['Content-Type'] = 'application/x-www-form-urlencoded;charset=UTF-8'
// axios.defaults.withCredentials = true;
axios.interceptors.response.use(
    function (response) {
        // 响应数据处理
        if (response.data.state) {
          if (response.data.state == -1) {
            let url = window.location.origin + '/#/' + getParams(JSON.parse(localStorage.getItem('href-url')))
            localStorage.removeItem('nsjkdjc==')
            window.location.href = url
            window.location.reload()
          }
        }
        return response;
    },
    function (error) {
        // 响应错误处理
        return Promise.reject(error);
    }
)

// 定义排序方法
function sortObjByKey(obj) {
    // 获取原对象集的key值赋给keys
    const keys = Object.keys(obj).sort()
    // 定义一个新的对象newObj，遍历keys并将每个key值添加到newObj，根据key匹配原对象集obj对应的key值
    let newObj = {}
    for (let i = 0; i < keys.length; i++) {
        const index = keys[i]
        newObj[index] = obj[index]
    }
    // 返回一个新的对象newObj（与原对象的区别：值为0或undefined的键值对，值变为空字符串）
    return newObj
}
// 将提交参数转化为FormData格式
export function getFormData(data) {
    let params = new FormData()
    Object.keys(data).forEach((key) => {
        params.append(key, data[key])
    })
    return params
}
function getParams(data) {
    const keys = Object.keys(data).sort()
    let urlParams = '?';
    for (let i = 0; i < keys.length; i++) {
        const index = keys[i]
        if (i == keys.length) {
            urlParams = urlParams + index + '=' + encodeURIComponent(data[index])
        } else {
            urlParams = urlParams + index + '=' + encodeURIComponent(data[index]) + '&'
        }
    }
    return urlParams
}

export function getReqData(data) {
    // 获取时间戳并转为字符串
    data.pgid = 59
    data.pid = 45
    data.gid = 1000796
    data.language = 3
    data.time = parseInt(Date.parse(new Date()) / 1000).toString()
    if (!data.duid && localStorage.getItem('browserId')) {
        data.duid = localStorage.getItem('browserId');
    }
    let reqData = sortObjByKey(data)
    // reqData.duid = localStorage.getItem('browserId');
    // 遍历reqData，去除sign用新变量tmpStr接
    let tmpStr = ''
    for (const key in reqData) {
        let tmp = ''
        if (key !== 'sign' && key !== 'file') {
            if (reqData[key]) {
                tmp = reqData[key]
            } else {
                reqData[key] = ''
            }
            tmpStr += key + '=' + tmp + '&'
        }
    }
    tmpStr = tmpStr.substr(0, tmpStr.length - 1) + 'haiwaidccd^$#scz*sx!sczsfv';
    reqData.sign = md5(tmpStr);
    return reqData
    // return getFormData(reqData);
}
export function getReqDataNoToken(data) {
    // 获取时间戳并转为字符串
    data.pgid = 59
    data.pid = 45
    data.gid = 1000796
    data.language = 3
    data.time = parseInt(Date.parse(new Date()) / 1000).toString()
    if (!data.duid && localStorage.getItem('browserId')) {
        data.duid = localStorage.getItem('browserId');
    }
    let reqData = sortObjByKey(data)
    // reqData.duid = localStorage.getItem('browserId');
    // 遍历reqData，去除sign用新变量tmpStr接
    let tmpStr = ''
    for (const key in reqData) {
        let tmp = ''
        if (key !== 'sign' && key !== 'file' && key !== 'token') {
            if (reqData[key]) {
                tmp = reqData[key]
            } else {
                reqData[key] = ''
            }
            tmpStr += key + '=' + tmp + '&'
        }
    }
    tmpStr = tmpStr.substr(0, tmpStr.length - 1) + 'haiwaidccd^$#scz*sx!sczsfv';
    reqData.sign = md5(tmpStr);
    return reqData
    // return getFormData(reqData);
}

// IP信息接口
export function IPInfoAPI() {
    return axios({
        url: '/home/ip/',
        method: 'post',
        data: '',
    })
}

// 首页内容接口
export function getHomeConfigAPI() {
    return axios({
        url: '/home/config?pgid=59',
        method: 'get'
    })
}

// 登录接口
export function loginAPI(params) {
    return axios({
        url: '/user/login/',
        method: 'post',
        data: getFormData(params),
    })
}
// 获取角色接口
export function getUserRoleAPI(params) {
    return axios({
        url: '/user/role/',
        method: 'post',
        data: getFormData(params),
    })
}

// 获取注意事项接口
export function getRemarkInfoAPI() {
    return axios({
        url: '/rebate/getRemark?pgid=59&pay_type=game',
        method: 'get'
    })
}
// 获取充值列表
export function getWayListAPI(params) {
    return axios({
        url: '/pay/waylistnew/' + getParams(params),
        method: 'get'
    })
}
// 获取充值档位接口
export function getPayNapeAPI(params) {
    return axios({
        url: '/pay/products/' + getParams(params),
        method: 'get'
    })
}
// 下单接口
export function createOrderAPI(params) {
    return axios({
        url: '/pay/createhw/',
        method: 'post',
        data: getFormData(params),
    })
}
// 支付接口
export function payComfigAPI(params) {
    return axios({
        url: '/pay/paygate/',
        method: 'post',
        data: getFormData(params),
    })
}
// 退出登录接口
export function loginoutAPI(params) {
    return axios({
        url: '/user/loginout/',
        method: 'post',
        data: getFormData(params),
    })
}
// 获取用户通信信息接口
export function getCommunicationAPI(params) {
    return axios({
        url: '/user/getCommunication/',
        method: 'post',
        data: getFormData(params),
    })
}
// 修改密码
export function changePwdAPI(params) {
    return axios({
        url: '/user/resetpwd/',
        method: 'post',
        data: getFormData(params),
    })
}
// 邮箱下发验证码接口
export function getVerifyCodeAPI(params) {
    return axios ({
        url: '/email/codeweb/' + getParams(params),
        method: 'get'
    })
}

// 绑定邮箱校验验证码接口
export function getBindCodeAPI(params) {
    return axios ({
        url: '/user/bindemail/' + getParams(params),
        method: 'get',
    })
}

// 换绑邮箱校验验证码接口
export function getUpBindCodeAPI(params) {
    return axios ({
        url: '/user/upbindemail/' + getParams(params),
        method: 'get'
    })
}
// 用户领取礼包奖励接口
export function sendGiftCodeAPI(params) {
    return axios({
        url: '/email/sendGiftCode',
        method: 'post',
        data: getFormData(params),
    })
}
// 获取储值记录
export function getAllPaymentAPI(params) {
    return axios({
        url: '/payment/getAllPayList/' + getParams(params),
        method: 'get'
    })
}





export function InitAPI(params) {
    return axios({
        url: '/init/index/',
        method: 'post',
        data: getFormData(params),
    })
}

// 获取奖励列表接口
export function GetProductsListAPI(params) {
    return axios({
        url: '/reserveorc/getList/',
        method: 'post',
        data: getFormData(params),
    })
}
// 获取活动详情接口
export function GetActivityInfoAPI(params) {
    return axios({
        url: '/reserveorc/activityInfo/',
        method: 'post',
        data: getFormData(params),
    })
}
// 获取邮箱验证码接口
export function SendEmailCodeAPI(params) {
    return axios({
        url: '/reserveorc/emailSendCode/',
        method: 'post',
        data: getFormData(params),
    })
}
// 邮箱验证码验证接口
export function VerifyEmailCodeAPI(params) {
    return axios({
        url: '/reserveorc/emailVerifyCode/',
        method: 'post',
        data: getFormData(params),
    })
}
// 获取任务列表接口
export function GetTaskListAPI(params) {
    return axios({
        url: '/reserveorc/getTaskStatus/',
        method: 'post',
        data: getFormData(params),
    })
}
// 获取任务列表接口
export function UpdateTaskStatusAPI(params) {
    return axios({
        url: '/reserveorc/updateTaskStatus/',
        method: 'post',
        data: getFormData(params),
    })
}
